import { StyleSheet } from 'react-native';
import React, { useEffect, useState } from "react";
import i18n from "utils/i18n";
import _ from "lodash";
import Form from "components/molecules/Form";
import { FormStatus } from 'utils/constants/form-constants';
import ThemedBlock from "components/atoms/ThemedBlock";
import HelperString from 'utils/helper-string'
import MutateTimeslot from 'utils/mutate/timeslot'
import ObjectTimeslot from 'utils/objects/timeslot'
import MutateToTimeslot, { MutateToTimeslotTables } from 'utils/mutate/to-timeslot'
import ObjectBuilding from 'utils/objects/building'
import HelperValidate from 'utils/helper-validate'
import LoadingComponent from 'components/atoms/Loading'
import { useSelector } from 'react-redux'
import { managementConstants } from 'services/redux/management/constants'
import ObjectTimeslotForm from 'utils/objects/timeslot-form'
import Button from 'theme/Button'
import store from 'services/redux/store'


const ManagementBuildingsComponentsTimeslotsScene = ({ building, floor, room, readonly, onSubmit }) => {
	
	const MODES = {
		BUILDING: 'building',
		FLOOR: 'floor',
		ROOM: 'room'
	}
	
	const [ formKey, setFormKey ] = useState( HelperString.random() )
	const [ loading, setLoading ] = useState( true )
	const [ createFormFieldProps, setCreateFormFieldProps ] = useState( {} )
	
	const formTimeslots = useSelector( state => {
		return state.management[managementConstants.SELECTED_TIMESLOTS];
	} )
	const { formFields, formValues } = formTimeslots
	
	const { disableKindBooking, itemKind, itemMode } = createFormFieldProps;
	
	const saveTimeslotForm = ( values, { callback } = {} ) => {
		const formTimeslots = store.getState().management[ managementConstants.SELECTED_TIMESLOTS ]
		const { formFields } = formTimeslots
		
		// Check if the value fields are available in the formValues
		const availableFormValueFields = _.map( formFields, o => {
			return o.name;
		} )

		values = _.pickBy( values, ( value, key ) => {
			return _.includes( availableFormValueFields, key )
		})
		
		//
		let table = null;
		let toTimeslotTables = null;
		let guid = null;
		
		switch( itemMode ) {
			case MODES.ROOM:
				table = MutateToTimeslotTables.ROOM;
				toTimeslotTables = MutateToTimeslotTables.ROOM;
				guid = room.guid;
				break;
			
			case MODES.FLOOR:
				table = MutateToTimeslotTables.FLOOR;
				toTimeslotTables = MutateToTimeslotTables.FLOOR;
				guid = floor.guid;
				break;
			
			default:
				table = MutateToTimeslotTables.BUILDING;
				toTimeslotTables = MutateToTimeslotTables.BUILDING;
				guid = building.guid;
				break;
		}
		
		MutateTimeslot.mutate( values, {
			table: table,
			guid: guid,
			callbackStart: callback.bind( this, FormStatus.LOADING ),
			callbackError: callback.bind( this, FormStatus.ERROR ),
			callbackSuccess: ( result ) => {
				MutateToTimeslot.mutate( toTimeslotTables, guid, result, {
					callbackSuccess: ( result ) => {
						callback( FormStatus.SUCCESS );
						
						setTimeout( () => {
							return callback(FormStatus.NONE);
						}, 2000 );
						
						if( _.isFunction( onSubmit ) ) {
							onSubmit()
						}
					},
					callbackError: ( result ) => {
						callback( FormStatus.ERROR );
					}
				})
			}
		} )
	};
	
	const addEmptyTimeslot = () => {
		ObjectTimeslotForm.addFormField( createFormFieldProps )
	}
	
	useEffect( () => {
		let item;
		let mode;
		let modeTimeslots;
		
		switch( true ) {
			case HelperValidate.isValid( room ):
				item = room;
				mode = MODES.ROOM;
				modeTimeslots = ObjectTimeslot.parse( room );
				break;
			
			case HelperValidate.isValid( floor ):
				item = floor;
				mode = MODES.FLOOR;
				modeTimeslots = ObjectTimeslot.parse( floor );
				break;
			
			default:
				item = building;
				mode = MODES.BUILDING;
				modeTimeslots = ObjectTimeslot.parse( building );
				break;
		}
		
		const fieldProps = {
			disableKindBooking: mode === MODES.BUILDING && ObjectBuilding.hasFloors( building ),
			itemMode: mode,
			itemKind: item['kind'],
		}
		
		setCreateFormFieldProps( fieldProps )
		ObjectTimeslotForm.setFormFields( modeTimeslots, fieldProps )
		setLoading( false )
	}, [] )

	let content = <LoadingComponent />
	if( !loading ) {
		content = (
			<Form
				key={ HelperString.hash( 'form-timeslots', formKey ) }
				values={ formValues }
				fields={ formFields }
				onSubmit={ saveTimeslotForm }
				disabled={ readonly }>

				{ !readonly && (
					<Button
						style={ staticStyles.buttonWidthAuto }
						appearance={"outline"}
						onPress={ addEmptyTimeslot.bind( this ) }>

						{ i18n.t('management:generic.timeslot.add') }
					</Button>
				)}
			</Form>
		)
	}
	
	return (
		<ThemedBlock
			header={ i18n.t('management:form_block.title_timeslot', { count: _.size( formValues ) } ) }
			shadow
			mediumPadding>
			
			{ content }
		</ThemedBlock>
	);
}

const staticStyles = StyleSheet.create({
	buttonWidthAuto: {
		width: 'auto',
	},
});

export default ManagementBuildingsComponentsTimeslotsScene
